import { Component, Input } from '@angular/core';
import { CardLookupDto } from '../lookup/card.lookup.dto';
import { Currency } from '../utils/currency';
import { CardStatus } from 'src/card.status';

@Component({
  selector: 'app-card-info',
  templateUrl: './card-info.component.html',
  styleUrls: ['./card-info.component.css']
})
export class CardInfoComponent {
  @Input() lookupObject?: CardLookupDto | null;
  cardStatus = CardStatus;

  get currentAmount(): string {
    return this.currencySymbol + " " + (this.lookupObject?.current_amount || 0).toFixed(2);
  }

  get initialAmount(): string {
    return this.currencySymbol + " " + (this.lookupObject?.initial_amount || 0).toFixed(2);
  }

  get showsOriginalAmount(): boolean {
    return (this.lookupObject?.current_amount ?? 0) < (this.lookupObject?.initial_amount ?? 0);
  }

  get expiration() {
    const lookupExpiration = this.lookupObject?.expires_at;

    if(!lookupExpiration) {
      return null;
    }
    
    const timestamp = lookupExpiration._seconds * 1000 + lookupExpiration._nanoseconds / 1_000_000;
    return new Date(timestamp);
  }

  get cardImage(): string {
    return this.lookupObject?.card_front_thumbnail || 'assets/letscard-template-virtual.svg';
  }

  private get currencySymbol(): string {
    return Currency.symbol(this.lookupObject?.currency || Currency.EUR);
  }

}
